require('./bootstrap');

window.Vue = require('vue').default;

import Vue from 'vue'
import Vuex from 'vuex'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'tabulator-tables/dist/css/tabulator_bootstrap5.min.css'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import App from './components/app/MainComponent.vue'
import loading from 'vuejs-loading-screen'
import router from './router'

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueSweetalert2)
Vue.use(require('vue-moment'));
Vue.use(loading, {
    bg: '#41b883ad',
    icon: 'fa fa-spinner',
    size: 3,
    icon_color: 'white',
})

window.moment = require('moment');

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(String(value)).format('DD-MM-YYYY hh:mm')
    }
})

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
    }
})

Vue.filter('formatDateTextMonth', function (value) {
    if (value) {
        let month = [
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember'
        ]
        let month_name = new Date(value).getMonth()
        return moment(String(value)).format('DD ') + month[month_name] + moment(String(value)).format(' YYYY')
    }
})

Vue.mixin({
    methods: {
        inArray(search, array) {
            let exist = false
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if (element == search) {
                    exist = true
                }
            }
            return exist
        },
        inObject(search, object) {
            let exist = false
            let array = Object.values(object)
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if (element == search) {
                    exist = true
                }
            }
            return exist
        }
    }
})

const store = new Vuex.Store({
    state: {
        auth_status: localStorage.getItem('access_token') ?? false,
        access_token: localStorage.getItem('access_token') ?? null,
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : [],
    },
    created() {
        this.getAuth()
    },
    mutations: {
        loadApp() {
            const app = new Vue(Vue.util.extend({ store, router }, App)).$mount('#app')
        },
        getAuth(state) {
            state.access_token = localStorage.getItem('access_token')
            state.user = JSON.parse(localStorage.getItem('user'))
        },
        setAuth(state, payload) {
            state.auth_status = payload.auth_status
            state.access_token = payload.access_token
            state.user = payload.user
            localStorage.setItem('auth_status', payload.auth_status)
            localStorage.setItem('access_token', payload.access_token)
            localStorage.setItem('user', JSON.stringify(payload.user))
        },
        removeAuth(state) {
            state.auth_status = false
            state.access_token = null
            state.user = []
            localStorage.removeItem('auth_status')
            localStorage.removeItem('access_token')
            localStorage.removeItem('user')
            window.location.href = '/login'
        }
    }
})

store.commit('loadApp')
